import styled, { css } from 'styled-components';
import { FlexRowBetween, FlexRowCenter } from '@styles/global-styles';

export const DialogHotspotProductWrapper = styled.div<{
  isHeightAuto?: boolean;
}>`
  background: var(--color-popup-bg);
  color: var(--color-popup-text);
  ${FlexRowBetween};
  align-items: flex-start;
  width: 100%;
  ${props =>
    !props.isHeightAuto &&
    css`
      height: 100%;
      /* height: 90vh;
      max-height: 560px; */
    `}
  .shopify {
    &-embed {
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }
  .galleries {
    width: 50%;
    height: 100%;
    background: #000;
    position: relative;
    display: flex;
    flex-flow: column;
    .image {
      width: 100%;
      height: 100%;
      img {
        width: unset !important;
        height: unset;
      }
      .input-position {
        height: 100%;
        > div {
          height: 100%;
          > img {
            width: 100% !important;
            object-fit: contain;
            height: 100%;
          }
        }
      }
    }
    .preview {
      width: 100%;
      display: flex;
      flex: 0 0 auto;
      margin: 12px 0;
      padding: 0 0.75rem;
      justify-content: center;
      &-item {
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 54px;
        height: 54px;
        border-radius: 2px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border: 2px solid #000;
        box-shadow: 0 0 0 1px rgb(255 255 255 / 0.25);
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            box-shadow: 0 0 0 1px rgb(255 255 255 / 0.5);
          }
          &.active {
            box-shadow: 0 0 0 1px rgb(255 255 255);
          }
        }
        &:not(:last-child) {
          margin-right: 12px;
        }
        &.more {
          .overlay {
            position: absolute;
            ${FlexRowCenter};
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            color: var(--color-popup-text);
            font-size: 11px;
            text-align: center;
            z-index: 2;
            background-color: rgba(0, 0, 0, 0.7);
          }
        }
      }
    }
  }
  .content {
    width: 50%;
    height: 100%;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 24px;
    .--top {
      border-bottom: 1px solid #dddddd4d;
      padding-bottom: 1rem;
    }
    .title {
      font-weight: 700;
      color: var(--color-popup-text);
      margin-bottom: 0.5rem;
      line-height: 120%;
    }
    .price {
      font-size: 16px;
      color: var(--color-popup-text);
    }
    .description {
      padding-top: 1rem;
      flex: 1;
      overflow: auto;
    }
    .action {
      margin-top: 24px;
      * {
        color: var(--color-icon) !important;
      }
      img {
        width: unset !important;
        height: unset;
      }

      .btn {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2ec26a;
        transition: all 0.15s ease-out;
        cursor: pointer;
        border-radius: 4px;
        padding: 12px;
      }
    }
  }
  @media (max-width: 575px) {
    flex-flow: column;
    height: auto;
    max-height: initial;
    .galleries {
      width: 100%;
      .image {
        height: 320px;
      }
    }
    .content {
      width: 100%;
    }
  }
`;
